module.exports = __webpack_public_path__ + "static/media/fire2.dc78b2c0.jpg";